import { isMobile } from '@/utils';
import Tracker from './tracker';

class CategoryTracker extends Tracker {
  /**
   *
   *  @description 类目页公共埋点
   *  @param {string} action 事件操作
   *  @param {object} eventLabel
   */
  CategoryPage = ({ action, eventLabel, category }) => {
    if (!eventLabel) return;
    try {
      let label = eventLabel || '';
      let value = '';

      // 页面埋点路径
      const pageMap = {
        '/accessory': 'accessory_page',
        '/service': 'service_page',
      };
      const terminal = isMobile() ? 'mobile' : 'pc';
      const page = pageMap?.[window.location.pathname] || 'accessory_page';

      this.commonTracker({
        category: category || `${terminal}_${page}`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new CategoryTracker();
export default T;
